import type { Waveform } from './synth-types';

export interface Preset {
  readonly waveform: Waveform;
  readonly attack: number;
  readonly release: number;
  readonly filter: number;
  readonly reverb: number;
  readonly echo: number;
}

export type PresetId = 'piano' | 'organ' | 'strings' | 'bass' | 'lead';

export const PRESETS: Readonly<Record<PresetId, Preset>> = {
  piano: { waveform: 'triangle', attack: 0.01, release: 0.9, filter: 5200, reverb: 0.18, echo: 0 },
  organ: { waveform: 'square', attack: 0.02, release: 0.06, filter: 9000, reverb: 0.1, echo: 0 },
  strings: { waveform: 'sawtooth', attack: 0.35, release: 1.3, filter: 3200, reverb: 0.35, echo: 0.12 },
  bass: { waveform: 'sine', attack: 0.005, release: 0.3, filter: 900, reverb: 0, echo: 0 },
  lead: { waveform: 'square', attack: 0.02, release: 0.22, filter: 6500, reverb: 0.2, echo: 0.28 },
};

export interface PresetButton {
  readonly id: PresetId | 'custom';
  readonly icon: string;
  readonly name: string;
}

/** Preset chooser, rendered as icon buttons. "custom" last — it is the
 *  "you've tweaked it" state rather than something you deliberately load. */
export const PRESET_BUTTONS: readonly PresetButton[] = [
  { id: 'piano', icon: '🎹', name: 'Pian' },
  { id: 'organ', icon: '🎛️', name: 'Orgă' },
  { id: 'strings', icon: '🎻', name: 'Coarde' },
  { id: 'bass', icon: '🎸', name: 'Bas' },
  { id: 'lead', icon: '⚡', name: 'Lead' },
  { id: 'custom', icon: '⚙️', name: 'Personalizat' },
];

export const INSTRUMENT_LABELS: Readonly<Record<string, string>> = {
  piano: 'Pian',
  'guitar-acoustic': 'Chitară acustică',
  'guitar-nylon': 'Chitară cu corzi de nylon',
  'guitar-electric': 'Chitară electrică',
  'bass-electric': 'Bas electric',
  bassoon: 'Fagot',
  cello: 'Cello',
  clarinet: 'Clarinet',
  contrabass: 'Contrabas',
  flute: 'Flaut',
  'french-horn': 'Corn francez',
  harmonium: 'Harmonium',
  harp: 'Harpă',
  organ: 'Orgă',
  saxophone: 'Saxofon',
  trombone: 'Trombon',
  trumpet: 'Trompetă',
  tuba: 'Tubă',
  violin: 'Vioară',
  xylophone: 'Xilofon',
};

/** Order instruments are offered in, most useful first. */
export const INSTRUMENT_ORDER: readonly string[] = [
  'piano',
  'guitar-acoustic',
  'guitar-nylon',
  'guitar-electric',
  'bass-electric',
  'harp',
  'organ',
  'harmonium',
  'xylophone',
  'violin',
  'cello',
  'contrabass',
  'flute',
  'clarinet',
  'bassoon',
  'saxophone',
  'trumpet',
  'trombone',
  'french-horn',
  'tuba',
];
